export const borders = {
  none: 0,
  '1px': '1px solid #CED2D5',
  '2px': '2px solid #CED2D5',
  '3px': '3px solid #CED2D5',
  '4px': '4px solid #CED2D5',
}
